import React from 'react'
import UploadIcon from 'client/utils/icons/upload-icon'
import { DcFlexBox, DcText } from 'pixel-base'

interface FileUploadDropzoneProps {
  onFileSelect: (files: File[]) => void
}

export const FileUploadDropzone: React.FC<FileUploadDropzoneProps> = ({
  onFileSelect,
}) => {
  const [isDragOver, setIsDragOver] = React.useState(false)
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null)
  const fileInputRef = React.useRef<HTMLInputElement>(null)

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragOver(true)
  }

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragOver(false)
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragOver(false)

    const files = Array.from(e.dataTransfer.files)
    if (files.length > 0) {
      const file = files[0]
      if (
        file.type === 'text/csv' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setSelectedFile(file)
        onFileSelect([file])
      }
    }
  }

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    if (files.length > 0) {
      const file = files[0]
      if (
        file.type === 'text/csv' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setSelectedFile(file)
        onFileSelect([file])
      }
    }
  }

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <DcFlexBox flexDirection="column" gap="10px">
      <div
        style={{
          border: `2px dashed ${isDragOver ? '#007bff' : '#dee2e6'}`,
          borderRadius: '8px',
          padding: '40px 20px',
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: isDragOver ? '#f8f9fa' : '#ffffff',
          transition: 'all 0.2s ease',
        }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />

        {selectedFile ? (
          <DcFlexBox flexDirection="column" gap="10px" alignItems="center">
            <DcText
              textSize="16px"
              style={{ color: '#28a745', fontWeight: '600' }}
            >
              ✅ File Selected
            </DcText>
            <DcText textSize="14px" style={{ color: '#495057' }}>
              {selectedFile.name}
            </DcText>
            <DcText textSize="12px" style={{ color: '#6c757d' }}>
              Click to select a different file
            </DcText>
          </DcFlexBox>
        ) : (
          <DcFlexBox flexDirection="column" gap="10px" alignItems="center">
            <UploadIcon size={48} color="#6c757d" />
            <DcText
              textSize="16px"
              style={{ fontWeight: '600', color: '#495057' }}
            >
              {isDragOver
                ? 'Drop your file here'
                : 'Drag and drop your file here'}
            </DcText>
            <DcText textSize="14px" style={{ color: '#6c757d' }}>
              or click to browse
            </DcText>
            <DcText textSize="12px" style={{ color: '#6c757d' }}>
              Supports CSV, XLSX, and XLS files
            </DcText>
          </DcFlexBox>
        )}
      </div>
    </DcFlexBox>
  )
}
